const prepareExtraFields = (schema, extrafields) => {
    if (!schema || (schema && !schema.tabs)) {
        return {};
    }

    let efSchema = {};
    schema.tabs.forEach((tab) => {
        if (Array.isArray(tab.fields)) {
            efSchema = tab.fields.reduce((obj, field) => {
                obj[field.fieldName] = field;
                return obj;
            }, efSchema);
        }
    });

    Object.keys(extrafields).forEach((key) => {
        const ef = efSchema[key];
        const val = extrafields[key];
        let tmpVal;
        if (ef) {
            switch (ef.type) {
                case 'int':
                    tmpVal = parseInt(val, 10);
                    extrafields[key] = tmpVal === 0 ? tmpVal : tmpVal || null;
                    break;
                case 'percentage':
                case 'currency':
                case 'decimal':
                    tmpVal = parseFloat(val, 10);
                    extrafields[key] = tmpVal === 0 ? tmpVal : tmpVal || null;
                    break;
                case 'list':
                    extrafields[key] = parseInt(val, 10) || -1;
                    break;
                default:
            }
        }
    });

    return extrafields;
};

const prepareFuzzyData = (field) => (field && field.value > 0 ? field.value : -1);

export const prepareSubmitData = (schema, values, initialValues, withPassword) => {
    const { environment, extraFields, photo, responsibleId, password, ...rest } = values;

    let result = {
        ...rest,
        extraFields: prepareExtraFields(schema, { ...extraFields }),
        environment: prepareFuzzyData(environment),
        responsibleId: prepareFuzzyData(responsibleId),
    };

    if (withPassword) result.password = password;

    const { photo: initialPhoto } = initialValues;
    if (initialPhoto !== photo) {
        result.photo = photo;
    }

    return result;
};

export const mapperUserToUserList = (userList, user) => {
    const { branch, responsible } = user;
    userList.email = user.email;
    userList.environment =
        branch && branch.id > 0
            ? {
                  id: branch.id,
                  name: branch.description,
              }
            : null;
    userList.externalId = user.extId;
    userList.isActive = user.isActive;
    userList.isBillable = user.isBillable;
    userList.lastName = user.lastName;
    userList.name = user.name;
    userList.phone = user.phone;
    userList.responsible =
        responsible && responsible.id > 0
            ? {
                  id: responsible.id,
                  value: responsible.value,
              }
            : null;
    userList.responsibleName = responsible && responsible.id > 0 ? responsible.value : '';
    userList.userEnvironment = branch && branch.id > 0 ? branch.description : '';
    userList.is2FAUserEnabled = user.is2FAUserEnabled;
};
